/**
 * Rolle "Eigentümer" — geseedet als id 1 in
 * backend-private/migration/20260126_744_assets.sql
 * (1=Eigentümer, 2=Mieter, 3=Hausverwalter).
 *
 * Eigentümer (Pfad B: Asset → LegalClientAsset) werden nicht über einen
 * eigenen Endpoint, sondern im selben Zug mit dem Vorgang gespeichert:
 * sie hängen als `OwnerArray` am jeweiligen Grundstück (RealEstateArray) und
 * werden vom Backend (relationship.py) beim Speichern/Laden auf das zugehörige
 * Asset gemappt.
 */
export const ID_LEGAL_CLIENT_ASSET_ROLE_OWNER = 1;
